
import { GridApi } from 'ag-grid-community';

export class ExineAgGrid {
  /* Public variables */
  columnDefs: any[];
  frameworkComponents;
  defaultColDef;
  context;
  gridOptions: any;
  rowSelection;
  rowClassRules;
  gridApi: GridApi;
  paginationPageSize;
  paginationNumberFormatter;
  desiredPaginationSize: number = 10;
  domLayout;
  rowData: any[] = [];


  constructor(

  ) {

    // set default grid settings
    this.gridOptions = {
      onCellDoubleClicked: undefined,
      onCellClicked: undefined,
      tooltipShowDelay: 500,
      onCellValueChanged: undefined,
      tooltipMouseTrack: true,
      paginationPageSizeSelector: [10, 20, 50, 100],
    }

    this.domLayout = 'autoHeight';

    this.paginationPageSize = 10;
    this.defaultColDef = {
      editable: false,
      sortable: true,
      flex: 1,
      filter: true,
      resizable: true,
      
      
      // tooltipComponent: 'customTooltip',
    };
    this.paginationNumberFormatter = function (params) {
      return params.value.toLocaleString();
    };
  }

  onPageSizeChanged() {
    this.gridApi.setGridOption('paginationPageSize',this.desiredPaginationSize);
  }

  csvExport(fileName) {
    this.gridApi.exportDataAsCsv({ fileName: fileName });
  }

  headerHeightGetter() {
    const columnHeaderTexts = document.querySelectorAll('.ag-header-cell-text');
    
    if (!columnHeaderTexts || columnHeaderTexts.length === 0) {
      return 0;
    }
    
    const columnHeaderTextsArray = Array.from(columnHeaderTexts);
    const clientHeights = columnHeaderTextsArray.map(
      (headerText: Element) => (headerText as HTMLElement).clientHeight
    );
    
    if (clientHeights.length === 0) {
      return 0;
    }
    
    const tallestHeaderTextHeight = Math.max(...clientHeights);
    return tallestHeaderTextHeight;
  }
  
  headerHeightSetter() {
    if (!this.gridApi) {
      return;
    }
    
    const padding = 20;
    const height = this.headerHeightGetter() + padding;
    
    if (height > padding) {
      this.gridApi.setGridOption('headerHeight', height);
      this.gridApi.resetRowHeights();
    }
  }
}